import type {
  FinanceStatus,
  Job,
  JobCreditState,
} from '@kanda-libs/ks-frontend-services';
import { useMemo } from 'react';
import JobCombinedStatus from '../JobCombinedStatus';
import JobPrice from '../JobPrice';

export interface JobPriceStatusProps {
  price: number;
  status?: Job['status'];
  financeStatus?: FinanceStatus;
  checkJobStatus?: JobCreditState['current_status'];
  paidByBank?: boolean;
  changesRequested?: boolean;
  archived?: boolean;
}

const JobPriceStatus: React.FunctionComponent<JobPriceStatusProps> = function ({
  price,
  status,
  financeStatus,
  checkJobStatus,
  paidByBank = false,
  changesRequested = false,
  archived = false,
}) {
  const showTags = useMemo(() => {
    if (!status && !financeStatus) return false;
    if (status === 'draft') return false;
    return true;
  }, [status, financeStatus]);

  return (
    <div className="flex flex-col gap-y-1">
      <JobPrice price={price} />
      {showTags && (
        <JobCombinedStatus
          status={status}
          financeStatus={financeStatus}
          archived={archived}
          paidByBank={paidByBank}
          changesRequested={changesRequested}
          checkJobStatus={checkJobStatus}
        />
      )}
    </div>
  );
};

export default JobPriceStatus;
